import React, { useState } from 'react';
import './FloatingWhatsApp.css';

const FloatingWhatsApp = () => {
  const [isHovered, setIsHovered] = useState(false);

  const whatsappLink = 'https://wa.me/447888396099?text=Hi%20West%20Drayton%20Body%20Works%2C%20I%20would%20like%20to%20get%20a%20quote%20for%20my%20vehicle.';

  return (
    <div
      className="floating-whatsapp"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button"
        title="Chat with us on WhatsApp"
      >
        <span className="whatsapp-icon">💬</span>
      </a>
      {isHovered && (
        <div className="whatsapp-tooltip">
          <p className="tooltip-text">Chat with us on WhatsApp!</p>
          <p className="tooltip-number">+44 7888 396099</p>
        </div>
      )}
    </div>
  );
};

export default FloatingWhatsApp;
